import React from "react";
import Box from "@mui/material/Box";
import accountTeamRingIcon from "@images/shi-ring.svg";

const accountTeamPath = "/my-account-team";

export function useGetAccountTeamNavItems() {
  return [
    {
      id: "my-account-team",
      type: "Link",
      displayName: "SHI Account Team",
      icon: (
        <Box
          component="img"
          src={accountTeamRingIcon}
          alt=""
          aria-hidden
          sx={{ width: 18, height: 18, display: "block" }}
        />
      ),
      path: accountTeamPath,
      visible: true,
    },
  ];
}
